export default {
  "lop-11": {
    seoTitle: "Lớp 11",
    title: "Lớp 11",
  },
  // "truyen": {
  //   seoTitle: "Truyện hay",
  //   title: "Truyện hay",
  // },
};